<template>
    <div class="mdl-grid">
        <div v-if="!isLoaded" class="loading-bar"></div>
        <div class="menu mdl-shadow--2dp mdl-grid mdl-cell mdl-cell--2-col-desktop mdl-cell--2-col-tablet mdl-cell--4-col-phone mdl-cell--top">
            <div v-for="(date, i) in months" :key="i"
                 class="month mdl-cell--top mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone"
                 :class="{'mdl-color--green-600 selected-date':selectedMonth===date}"
                 @click="loadMonth(date)">
                <div>{{date.year}}, {{ date.month }}</div>
            </div>
        </div>
        <div id="people" class="mdl-cell mdl-cell--8-col-desktop mdl-cell--6-col-tablet mdl-cell--1-offset-desktop">
            <message-bar type="warning" v-if="this.summary === null" style="margin: auto">Zvolte měsíc..</message-bar>
            <div v-else>
                <div class="mdl-grid">
                    <button :disabled="!isLoaded" class="mdl-button mdl-button--raised mdl-cell--1-col mdl-cell--6-offset-desktop mdl-cell--3-offset-tablet" @click="print()">Tisk</button>
                    <span :disabled="!isLoaded" class="mdi mdi-microsoft-excel mdl-button mdl-button--raised mdl-cell--2-col" @click="dwonloadUsers()"
                        style="margin-left: 8px"> Strávníci</span>
                    <span :disabled="!isLoaded" class="mdi mdi-microsoft-excel mdl-button mdl-button--raised mdl-cell--2-col" @click="dwonloadRestaurants()"
                        style="margin-left: 8px"> Restaurace</span>
                </div>
                
                <accounting-all-users-summary id="users-list" :summary="summary"></accounting-all-users-summary>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import config from "../config";
    import MessageBar from "../components/widgets/MessageBar";
    import AccountingAllUsersSummary from "../components/AccountingAllUsersSummary";

    export default {
        name: "Accounting",
        components: {AccountingAllUsersSummary, MessageBar},
        data() {
            return {
                host: String,
                months: Array,
                summary: null,
                selectedMonth: null,
                loaded: Boolean
            }
        },
        methods: {
            async dwonloadRestaurants() {
                let xsls = await axios.get(config.host + "/v1/accounting/" + this.selectedMonth.year + "/" + this.selectedMonth.month+"/restaurants/xlsx",{
                        responseType: "arraybuffer",
                        responseEncoding: "binary"
                    })
                var file = new Blob([xsls.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(file);
                let filename = "restaurace_"+this.selectedMonth.year + "-" + this.selectedMonth.month+".xlsx"
                link.download = filename;
                link.click();
                URL.revokeObjectURL(link.href);
            },
            async dwonloadUsers() {
                let xsls = await axios.get(config.host + "/v1/accounting/" + this.selectedMonth.year + "/" + this.selectedMonth.month+"/users/xlsx",{
                        responseType: "arraybuffer",
                        responseEncoding: "binary"
                    })
                var file = new Blob([xsls.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(file);
                let filename = "stravnici_"+this.selectedMonth.year + "-" + this.selectedMonth.month+".xlsx"
                link.download = filename;
                link.click();
                URL.revokeObjectURL(link.href);
            },
            loadMonth: function (date) {
                this.loaded = false;
                this.selectedMonth = date;
                axios.get(config.host + "/v1/accounting/" + date.year + "/" + date.month)
                    .then(result => {
                        this.summary = result.data
                        this.loaded = true
                    });
            },
            print: function print() {
                var mywindow = window.open('', 'PRINT', 'height=400,width=600');

                mywindow.document.write('<html><head><title>LOS ' + this.selectedMonth.year + ', ' + this.selectedMonth.month + '</title>');
                mywindow.document.write('<link rel="stylesheet" href="https://code.getmdl.io/1.3.0/material.green-deep_orange.min.css" />');
                mywindow.document.write('<style>.mdl-cell { margin: 0}</style>');
                mywindow.document.write('</head><body >');
                mywindow.document.write(document.getElementById("users-list").innerHTML);
                mywindow.document.write('</body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/

                mywindow.print();
                mywindow.close();

                return true;
            }
        },
        mounted() {
            this.host = config.host;

            axios.get(config.host + "/v1/accounting/months")
                .then(result => this.months = result.data);
        },

        computed: {
            isLoaded() {
                return this.loaded
            }
        }
    }
</script>

<style scoped>
    .month {
        padding: 0.5em;
        font-size: 20px;
    }

    .month:hover {
        cursor: pointer;
    }

    .selected-date {
        color: white;
    }

    .menu {
        padding: 0;
    }

    .loading-bar {
        height: 5px;
        width: 40%;
        background-color: #FFB333;
        position: absolute;
        top: 0px;
        left: -20%;
        animation: loading 3s ease-in-out 0s infinite;
        z-index: 100;
        }

        @keyframes loading {
        from {
        transform:translateX(0)
        }
        30% {
        transform:translateX(230%)
        }
        }

        @keyframes mymove {
            from {
                transform: rotate(-360deg);
            }
        }

</style>